import { useContext, useEffect } from "react";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";

const useSetMissceleneous = ({ listeners, data, updateHandler }) => {
  const { set_miscellaneous_data, setMiscellaneousUpdate } = useContext(
    WebpageCreationContext
  );

  useEffect(() => {
    setMiscellaneousUpdate((prev) => ({
      ...prev,
      ...updateHandler,
    }));
    set_miscellaneous_data({ ...data });
  }, listeners);
};

export default useSetMissceleneous;
